import CustomView, {
    CustomViewInput,
} from "@/domain/entities/customViews/CustomView";
import { useToast } from "@/hooks/utils/useToast";
import {
    customViewInputToSDKMapper,
    customViewToDomainMapper,
} from "@/mappers/customView/customViewMapper";
import {
    CustomViewInput as CustomViewInputSDK,
    useSdk,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useTranslation } from "react-i18next";

const useCreateView = () => {
    const { customViewManager } = useSdk();
    const { toast } = useToast();
    const { t } = useTranslation();

    const createView = async (
        view: CustomViewInput,
    ): Promise<CustomView | undefined> => {
        try {
            const sdkInput: CustomViewInputSDK =
                customViewInputToSDKMapper(view);
            const createdView = await customViewManager.createView(sdkInput);
            const domainCustomView = customViewToDomainMapper(createdView);

            return domainCustomView;
        } catch (error) {
            console.error(error);
            toast({
                title: t("errors.customViews.createView"),
                description: t("errors.global.description"),
                variant: "error",
            });
        }
    };

    return createView;
};

export default useCreateView;
